import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-form-sections',
  templateUrl: './form-sections.component.html',
  styleUrls: ['./form-sections.component.scss']
})
export class FormSectionsComponent implements OnInit {
  @Input() isLoading;
  @Input() sections: any;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onFormDone: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  payload: any = [];
  isValid = false;
  constructor() { }
  ngOnInit(): void {
  }
  formEventListener({form, payload, formIndex}) {
    this.payload[formIndex] = payload;
    if (payload && payload.MULTI_SELECT) {
      const temp = payload.MULTI_SELECT.split(',');
      if (temp[0] === '') {
         temp.pop();
      }
      if (temp.length === 1 || temp.length > 4) {
        this.isValid = false;
        return;
      }
    }
    this.isValid = form.valid;
  }
  onFormSubmited() {
    this.onFormDone.emit({payload: this.payload});
  }
  closeForm() {
    this.cancel.emit();
  }
}
